import { render, staticRenderFns } from "./ChangePassword.vue?vue&type=template&id=32a96798&scoped=true&"
import script from "./ChangePassword.js?vue&type=script&lang=js&"
export * from "./ChangePassword.js?vue&type=script&lang=js&"
import style0 from "./ChangePassword.vue?vue&type=style&index=0&id=32a96798&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32a96798",
  null
  
)

export default component.exports